<script lang="ts" setup>
    import { Validation } from '~/data/Validation'

    const {
        field,
        modelValue,
        showLabel = true,
        fitContent = false,
        inputClasses = '',
    } = defineProps<{
        field: Field
        modelValue?: string
        showLabel?: boolean
        fitContent?: boolean
        inputClasses?: string
    }>()

    const emit = defineEmits(['update:modelValue'])

    const placeholder = computed(() => {
        let placeholder = field.placeholder ?? ''

        if (
            field.validate &&
            field.validate.indexOf(Validation.required) !== -1
        ) {
            if (placeholder === '') {
                placeholder = field.display
            }

            placeholder += ' *'
        }

        return placeholder.toUpperCase()
    })

    const valueHolder = ref()
    const inputEl = ref()

    const updateInputWidth = () => {
        if (!inputEl.value) {
            return
        }

        setTimeout(
            () =>
                (inputEl.value.style.width = `${valueHolder.value.clientWidth + 50}px`),
            1,
        )
    }

    if (fitContent) {
        watch(
            () => modelValue,
            () => updateInputWidth(),
        )

        onMounted(() => {
            new EfficientResizeListener(updateInputWidth)
        })
    }
</script>

<template>
    <InputFrame :field="field" :showLabel="showLabel" :fitContent="fitContent">
        <span
            v-if="fitContent"
            ref="valueHolder"
            class="value-holder invisible absolute normal-case"
        >
            {{ modelValue || placeholder }}
        </span>

        <component
            ref="inputEl"
            :value="modelValue"
            @input="emit('update:modelValue', $event.target.value)"
            :is="field.type === 'textarea' ? 'textarea' : 'input'"
            :type="field.input_type"
            :name="field.handle"
            class="peer w-full bg-none px-3 py-1 text-dark outline-none transition xl:px-4 xl:py-2"
            :class="inputClasses"
            :required="
                field.validate &&
                field.validate.indexOf(Validation.required) !== -1
            "
            :placeholder="showLabel ? null : placeholder"
        />
    </InputFrame>
</template>
